export default __webpack_public_path__ + "static/media/ic_calendar.c6f9502e.svg";